
import wallet from "../../hook/wallet/contentWallet"
import PublicDialog from "../PublicDialog";
import ButtonComp from "./ButtonComp";
import useH5Config from "../../h5/config/useH5Config.tsx"
import useConnectBscWallet from "../../h5/config/useConnectBscWallet.tsx"
import { useWeb3React } from "@web3-react/core";
import { useEffect } from "react";
import { Toast } from "react-vant";
import { useAccount } from "wagmi";
import { useTranslation } from "react-i18next";

interface Props {
    callback?: () => void
}
const ConnectWallet = ({ callback }: Props) => {
    const { isH5 } = useH5Config()
    const { t } = useTranslation();
    const { bscConnectWallet, isShowBscConnectWallet, setShowConnectWallet } = useConnectBscWallet()
    // const { activate, deactivate, account } = useWeb3React()
    const { address: account, isConnected } = useAccount();
    const { useConnectWallet } = wallet();


    const connectWallet = async (el?: any) => {
        useConnectWallet(el, callback && callback());
    }


    const connect_wallet_button = () => {
        return (
            <div className='flex flex-col items-center justify-around mx-auto h-[216px] py-5'>
                <p className='text-sm text-[#333]'>
                    {t("h5.connect_wallet")}
                </p>
                <ButtonComp callBack={() => {
                    if (isH5) {
                        setShowConnectWallet(true)

                    } else {
                        connectWallet()
                    }

                }} title={t("components.settingsDialog.connect")}></ButtonComp>
            </div >
        )
    }

useEffect(() => {
    if (account) {
        callback && callback()
    }
}, [account])
return (
    <>
        <PublicDialog teleport={document.querySelector('body')} width={"290px"} isPadding={false} closeOnClickOverlay={false} dialog={true} setDialog={() => {
            callback && callback()
        }} content={connect_wallet_button()} customClassName="customClassName"></PublicDialog>
        {
            isShowBscConnectWallet && bscConnectWallet()
        }

    </>
)
}

export default ConnectWallet